export var makeSelected = function makeSelected(chainid, option, cost, displayName) {
  return {
    optionChainId: chainid,
    optionId: option,
    optionName: displayName,
    cost: cost
  };
};